import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { NoAuthGuard } from './core/guards/no-auth.guard';
import { ExampleComponent } from './features/example/example/example.component';
import { ManualPDFAComponent } from './features/example/manual-pdf-a/manual-pdf-a.component';
import { PaymentBillFeeComponent } from './features/payment/payment-bill-fee/payment-bill-fee.component';
import { PaymentBillComponent } from './features/payment/payment-bill/payment-bill.component';
import { WebViewTermOfUseComponent } from './features/term-of-use/term-of-use.component';
import { ContactUsComponent } from './features/user/contact-us/contact-us.component';
import { WebViewNotificationsComponent } from './features/web-view-notifications/web-view-notifications.component';
import { ThaidCallbackComponent } from './features/thaid-callback/thaid-callback.component';
import { ManualComponent } from './features/manual/manual/manual.component';
import { ManualAdminCurdBookComponent } from './features/manual-super-admin/manual-admin-curd-book/manual-admin-curd-book/manual-admin-curd-book.component';
import { ThaidUpdateComponent } from './features/edit-user/edit-user-tab/thaid-update/thaid-update.component';
import { LinkManualComponent } from './features/link-manual/link-manual.component';
import { PolicyComponent } from './features/policy/policy.component';

const routes: Routes = [
   {
    path: 'policy',
    component: PolicyComponent
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/guest/guest.module').then((m) => m.GuestModule),
  },
  {
    path: 'login',
    // canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'forget',
    // canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./features/forget/forget.module').then((m) => m.ForgetModule),
  },
  {
    path: 'register',
    // canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./features/register/register.module').then(
        (m) => m.RegisterModule
        ),
  },
  {
    path: 'civil-court',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/user/civil-court/civil-court.module').then(
        (m) => m.CivilCourtModule
      ),
  },
  {
    path: 'high-court',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/user/high-court/high-court.module').then(
        (m) => m.HighCourtModule
      ),
  },
  {
    path: 'my-case',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/user/my-case/my-case.module').then(
        (m) => m.MyCaseModule
      ),
  },
  {
    path: 'payment',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/payment-detail/payment-detail.module').then(
        (m) => m.PaymentDetailModule
      ),
  },
  {
    path: 'payment-court-fees',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/payment-court-fees/payment-court-fees.module').then(
        (m) => m.PaymentCourtFeesModule
      ),
  },
  {
    path: 'example/:path',
    component: ExampleComponent,
  },
  {
    path: 'contact-us',
    loadChildren: () =>
      import('./features/user/contact-us/contact-us.module').then((m) => m.ContactUsModule),
  },
  {
    path: 'manual-pdf_a',
    component: ManualPDFAComponent,
  },
  {
    path: 'payment-court-fees/payment/bill/:caseId/:billId',
    component: PaymentBillComponent,
  },
  {
    path: 'payment-court-fees/payment/bill/fee/:caseId/:billId/:isAppeal',
    component: PaymentBillFeeComponent,
  },
  {
    path: 'verify-email',
    //canActivate: [NoAuthGuard],
    loadChildren: () =>
      import('./features/verity-email/verify-email.module').then(
        (m) => m.VerifyEmailModule
      ),
  },
  {
    path: 'edit-user',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/edit-user/edit-user.module').then(
        (m) => m.EditUserModule
      ),
  },
  {
    path: 'thaid-update',
    component: ThaidUpdateComponent,
  },
  {
    path: 'manual-book',
    //loadChildren: () => import('./features/register/register.module').then(m => m.Manual)
    //component: ManualComponent,
    component: ManualComponent,
  },
  {
    path: 'manual-admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/manual-super-admin/manual-super-admin.module').then(m => m.ManualSuperAdminModule)
    //component: ManualAdminCurdBookComponent,
  },

  {
    path: 'link-manual-book',
    //loadChildren: () => import('./features/register/register.module').then(m => m.Manual)
    //component: ManualComponent,
    component: LinkManualComponent,
  },

  {
    path: 'term-of-use',
    component: WebViewTermOfUseComponent,
  },
  {
    path: 'notifications/:id',
    component: WebViewNotificationsComponent,
  },
  {
    path: 'thaid-callback',
    component: ThaidCallbackComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/login',
    // redirectTo: '/u/dashboard'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled', // Add options right here
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
